"use client";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import axios from "axios";
import { LuCheck } from "react-icons/lu";
import { config } from "../../utils/config";
import { FaCircleCheck } from "react-icons/fa6";
import { Button, Modal, Spin } from 'antd';
import { LoadingOutlined, LockOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';

export default function BusinessDetailsStep({ data, setData, verifyGST, isPANVerified, setShowPanfield, showPanField, setIsPANVerified, verifyPanDetails, setIsGSTVerified, isGSTVerified, setPrefillBasicData, prefillBasicData }) {
    const [taxType, setTaxType] = useState("gst");
    const [loading, setLoading] = useState(false);
    console.log("getting data are ", verifyGST)
    console.log("getting data ", data)

    // const [isGSTVerified, setIsGSTVerified] = useState(false);
    const handleChange = (e) => {
        const { name } = e.target;
        let value = e.target.value;

        if (name === "gst_number") {
            // Alphanumeric only, uppercase, no special chars (@# etc.), max 15
            value = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15);
            setIsGSTVerified(false);
        } else if (name === "pan_number") {
            // Alphanumeric only, uppercase, no special chars (@# etc.), max 10
            value = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);
            setIsPANVerified(false);
        } else if (name === "pincode") {
            value = value.replace(/\D/g, "").slice(0, 6);
        }

        setData({
            ...data,
            [name]: value,
            ...(taxType === "gst" && { gst_image: STATIC_IMAGES.gst_image }),
            ...(taxType === "nonGst" && { pan_image: STATIC_IMAGES.pan_image }),
            logo: STATIC_IMAGES.logo
        });
    };

    const verifyGSTHandler = async () => {
        try {
            setLoading(true);
            const res = await verifyGST(data.gst_number);
            console.log("GST API Full Response:", res);

            // Handle nesting levels: res?.data?.data?.data or res?.data?.data or res?.data or res
            const raw = res?.data?.data || res?.data || res?.response?.data || res || {};
            const gstData = raw?.data || raw;

            if (gstData && (gstData.gst_number || gstData.gst_no || gstData.business_name || gstData.pan_name || gstData.company_name)) {
                const companyName = gstData.business_name || gstData.pan_name || gstData.company_name || "";
                const panNo = gstData.business_pan || gstData.pan_no || gstData.pan_number || "";
                const businessType = gstData.business_entity_type || gstData.bussiness_type || "";
                const gstNo = gstData.gst_number || gstData.gst_no || data.gst_number || "";

                // Address fields directly from API response
                const state = gstData?.state || "";
                const city = gstData?.city || "";
                const pincode = gstData?.pincode ? String(gstData.pincode).trim() : "";

                setData({
                    ...data,
                    gst_number: gstNo,
                    gst_no: gstNo,
                    company_name: companyName,
                    bussiness_type: businessType,
                    pan_number: panNo,
                    pan_no: panNo,
                    pan_name: gstData.pan_name || companyName,
                    street: data?.street || "",
                    locality: data?.locality || "",
                    state: state || data.state || "",
                    city: city || data.city || "",
                    pincode: pincode || data.pincode || "",
                });
                setIsGSTVerified(true);
                toast.success(res?.message || "GST verified successfully!");
            } else {
                setIsGSTVerified(false);
                toast.error(res?.message || "GST verification is unsuccessful!");
            }
        } catch (error) {
            setIsGSTVerified(false);
            console.log("GST Error:", error);
            toast.error(error?.message || "GST verification is unsuccessful!");
        } finally {
            setLoading(false);
        }
    };

    const STATIC_IMAGES = {
        gst_image: "https://example.com/images/gst.jpg",
        pan_image: "https://example.com/images/pan.jpg",
        logo: "https://example.com/images/logo.jpg"
    };

    const isValidGST = (gst) => {
        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/;
        return gstRegex.test(gst);
    };

    const [isLoading, setIsLoading] = useState(false);
    const verifyPanHandler = async () => {
        try {
            setIsLoading(true);
            const res = await verifyPanDetails(
                data.pan_name,
                data.pan_number
            );
            console.log("PAN RESPONSE:", res);
            if (res?.status === false) {
                setIsPANVerified(false);
                toast.error(res?.message || "PAN verification failed!");
            } else {
                setIsPANVerified(true);
                toast.success(res?.message || "PAN verified successfully!");
            }
        } catch (err) {
            setIsPANVerified(false);
            console.log("PAN Error:", err);
            toast.error(err?.message || "PAN verification failed!");
        } finally {
            setIsLoading(false);
        }
    };

    const isValidPAN = (pan) => {
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        return panRegex.test(pan);
    };

    // const query = new URLSearchParams(useLocation().search);
    // const seller_id = query.get("seller_id");
    // const client_token = query.get("client_token");
    // const state = query.get("state");



    return (
        <>
            <div >

                <h2 className="h4 fw-semibold py-1 mt-3" style={{ color: "black", fontSize: "20px" }}>
                    Business Information
                </h2>

                <div className="border shadow-sm bg-white" style={{ borderRadius: "14px", maxHeight: "55vh", overflowX: "scroll" }}>

                    {/* ================= Tax Information ================= */}
                    <div className="mt-4">
                        <div className="card-body p-4 pt-0">
                            <div className="d-flex gap-3 mb-3" style={{ gap: "20px" }}>
                                <div
                                    className={`px-2 py-1 border rounded d-flex align-items-center ${taxType === "gst" ? "border-warning bg-light" : "border-secondary"}`}
                                    onClick={() => setTaxType("gst")}
                                    style={{ cursor: "pointer", gap: "8px" }}
                                >
                                    <input type="radio" checked={taxType === "gst"} readOnly onChange={() => {
                                        if ((window.gtag).gtag) {
                                            (window.gtag).gtag("event", "gst_clicked", {
                                                event_category: "Tax",
                                                event_label: "GST Selected",
                                            });
                                        }
                                    }} />
                                    <span className="ms-2">GST</span>
                                </div>

                                {/* <div
                                className={`px-2 py-1 border rounded d-flex align-items-center ${taxType === "nonGst" ? "border-warning bg-light" : "border-secondary"}`}
                                onClick={() => setTaxType("nonGst")}
                                style={{ cursor: "pointer", width: "120px", gap: "8px" }}
                            >
                                <input type="radio" checked={taxType === "nonGst"} readOnly />
                                <span className="ms-2">Non-GST</span>
                            </div> */}

                            </div>

                            {taxType === "gst" && (
                                <>
                                    <div className="mb-3">
                                        {isGSTVerified && data?.gst_number ? <div className="alert mb-3 alert-success mb-0 p-2" style={{ color: "green", background: "#e8f3e8" }}>
                                            <FaCircleCheck /> Your GST number has been verified successfully.
                                        </div> : null}
                                        <label className="form-label">
                                            GST Number <span className="text-dark fw-bold">*</span>
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type="text"
                                                name="gst_number"
                                                value={data.gst_number || ""}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === " " || /[@#$%^&*!~+=<>?/\\{}()[\]|`"';:,._-]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                    if (!/[a-zA-Z0-9]/.test(e.key) && !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onPaste={(e) => {
                                                    e.preventDefault();
                                                    const pasted = (e.clipboardData?.getData("text") || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15);
                                                    handleChange({ target: { name: "gst_number", value: pasted } });
                                                }}
                                                className="form-control"
                                                placeholder="Enter GST Number (e.g. 07AAAAA0000A1Z5)"
                                                maxLength={15}
                                                style={{ background: "#F3F3F5", textTransform: "uppercase" }}
                                                readOnly={isGSTVerified && data?.gst_number ? true : false}
                                            />

                                            {isGSTVerified && data?.gst_number ? (
                                                <span className="position-absolute fw-bold text-success" style={{ right: "8px", top: "50%", transform: "translate(0px, -50%)" }}>
                                                    <LuCheck />
                                                </span>
                                            ) : (
                                                <button
                                                    type="button"
                                                    onClick={verifyGSTHandler}
                                                    disabled={!isValidGST(data?.gst_number) || loading}
                                                    className="position-absolute text-white px-3 py-1 h-100 fw-semibold"
                                                    style={{
                                                        top: "0px",
                                                        right: "0px",
                                                        background: "linear-gradient(90deg, #F75710, #FC8809)",
                                                        color: "#fff",
                                                        border: "none",
                                                        outline: "none",
                                                        borderRadius: "8px",
                                                        opacity: loading ? 0.6 : 1
                                                    }}
                                                >
                                                    {loading ? "Verifying..." : "Verify"}
                                                </button>
                                            )}
                                        </div>

                                        {data?.gst_number && !isValidGST(data?.gst_number) && (
                                            <small className="text-danger">Invalid GST Number (Format: 15 alphanumeric characters)</small>
                                        )}
                                    </div>

                                    {/* show field n */}
                                </>
                            )}

                            {taxType === "nonGst" && (
                                <>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            PAN Card Number <span className="">*</span>
                                        </label>

                                        <input
                                            type="text"
                                            name="pan_number"
                                            value={data.pan_number || ""}
                                            onChange={handleChange}
                                            onKeyDown={(e) => {
                                                if (e.key === " " || /[@#$%^&*!~+=<>?/\\{}()[\]|`"';:,._-]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                                if (!/[a-zA-Z0-9]/.test(e.key) && !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onPaste={(e) => {
                                                e.preventDefault();
                                                const pasted = (e.clipboardData?.getData("text") || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);
                                                handleChange({ target: { name: "pan_number", value: pasted } });
                                            }}
                                            className="form-control"
                                            placeholder="Enter PAN Card Number (e.g. ABCDE1234F)"
                                            maxLength={10}
                                            style={{ textTransform: "uppercase" }}
                                        />
                                    </div>

                                    <div>
                                        <label className="form-label">
                                            Pan Name<span className="fw-bold">*</span>
                                        </label>

                                        <input
                                            type="text"
                                            name="pan_name"
                                            value={data?.pan_name || ""}
                                            placeholder="Enter Pan Name"
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                    </div>
                                    {!isPANVerified ? (
                                        <button className="btn d-flex mt-3 justify-content-end"
                                            onClick={verifyPanHandler}
                                            disabled={
                                                !isValidPAN(data.pan_number) ||
                                                !data.pan_name ||
                                                isLoading
                                            }
                                            style={{
                                                top: "0px",
                                                right: "0px",
                                                background: "linear-gradient(90deg, #F75710, #FC8809)",
                                                color: "#fff",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: "8px",
                                                opacity: isLoading ? 0.6 : 1
                                            }} >
                                            {isLoading ? "Processing..." : "Verify PAN"}
                                        </button>
                                    ) : (
                                        <p className="mt-2 mb-0" style={{ color: "green" }}>
                                            Pan Verified ✅
                                        </p>
                                    )}
                                </>
                            )}
                        </div>
                        <div className="mx-4 border-bottom"></div>
                    </div>
                    {(
                        (taxType === "gst" && isGSTVerified && data?.gst_number) ||
                        (taxType === "nonGst")
                    ) && (
                            <>
                                <div className="p-4">
                                    <h5 className="mb-3 fw-bold" style={{ color: "#000" }}>Business Details</h5>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Business Type<span className="">*</span></label>
                                            <input
                                                type="text"
                                                name="bussiness_type"
                                                value={data?.bussiness_type || ""}
                                                onChange={handleChange}
                                                className="form-control inputForm"
                                                placeholder="Business Type"
                                                readOnly={Boolean(prefillBasicData?.bussiness_type || prefillBasicData?.business_type)}
                                                style={{ background: (prefillBasicData?.bussiness_type || prefillBasicData?.business_type) ? "#F3F3F5" : "#FFFFFF" }}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label>Business Name<span className="">*</span></label>
                                            <input
                                                type="text"
                                                name="company_name"
                                                value={data?.company_name || ""}
                                                onChange={handleChange}
                                                className="form-control"
                                                placeholder="Company Name"
                                                readOnly={Boolean(prefillBasicData?.company_name || prefillBasicData?.business_name || prefillBasicData?.pan_name)}
                                                style={{ background: (prefillBasicData?.company_name || prefillBasicData?.business_name || prefillBasicData?.pan_name) ? "#F3F3F5" : "#FFFFFF" }}
                                            />
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label>Seller Type<span className="text-dark fw-bold">*</span></label>
                                            <select
                                                name="seller_type"
                                                value={data.seller_type || ""}
                                                onChange={handleChange}
                                                className="form-control"
                                                style={{ background: "#F3F3F5" }}
                                            >
                                                <option value="">Select Seller Type</option>
                                                <option value="wholesaler">Wholesaler</option>
                                                <option value="distributor">Distributor</option>
                                                <option value="manufacturer">Manufacturer</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="mx-4 border-bottom"></div>

                                <div className="p-4">
                                    <h5 className="mb-3 fw-bold" style={{ color: "#000" }}>Business Address</h5>

                                    <div className="d-flex" style={{ gap: "22px" }}>

                                        <div className="w-50">
                                            <label>Street<span className="">*</span></label>
                                            <input type="text"
                                                name="street"
                                                value={data.street || ""}
                                                onChange={handleChange}
                                                className="form-control"
                                                placeholder="Street / Building No"
                                                style={{ background: "#FFFFFF" }}
                                            />
                                        </div>

                                        <div className="w-50">
                                            <label>Locality<span className="">*</span></label>
                                            <input type="text"
                                                name="locality"
                                                value={data.locality || ""}
                                                onChange={handleChange}
                                                className="form-control"
                                                placeholder="Locality / Area"
                                                style={{ background: "#FFFFFF" }}
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex gap-3 mt-3" style={{ gap: "22px" }}>
                                        <div className="w-50">
                                            <label>Pincode<span className="">*</span></label>
                                            <input
                                                type="text"
                                                name="pincode"
                                                value={data.pincode || ""}
                                                onChange={handleChange}
                                                className="form-control mb-2"
                                                placeholder="Pincode"
                                                maxLength={6}
                                                style={{ background: "#FFFFFF" }}
                                            />
                                        </div>
                                        <div className="w-50">
                                            <label>City<span className="">*</span></label>
                                            <input
                                                type="text"
                                                name="city"
                                                value={data.city || ""}
                                                onChange={handleChange}
                                                className="form-control mb-2"
                                                placeholder="City"
                                                style={{ background: "#FFFFFF" }}
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex gap-3 mt-2" style={{ gap: "22px" }}>
                                        <div className="w-50">
                                            <label>State<span className="">*</span></label>
                                            <input
                                                type="text"
                                                name="state"
                                                value={data.state || ""}
                                                onChange={handleChange}
                                                className="form-control mb-2"
                                                placeholder="State"
                                                style={{ background: "#FFFFFF" }}
                                            />
                                        </div>
                                        <div className="w-50">
                                            <label>Country<span className="">*</span></label>
                                            <input
                                                type="text"
                                                name="country"
                                                value={data.country || "India"}
                                                onChange={handleChange}
                                                className="form-control mb-2"
                                                placeholder="Country"
                                                style={{ background: "#FFFFFF" }}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </>
                        )}
                </div>
            </div>

            <Modal
                open={loading}
                footer={null}
                closable={false}
                centered
                width={450}
                style={{ borderRadius: "20px" }}

            >
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <p style={{ fontWeight: "600", fontSize: "20px" }} className="m-0"> Verifying your GST Number</p>
                    <p style={{ color: "gray" }} className="mt-1">this usually takes few seconds</p>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: "orange" }} spin />} />
                    <p style={{ marginTop: "15px", gap: "10px", color: "gray" }} className="d-flex justify-content-center align-items-center">
                        <LockOutlined /> <span> Your details are securely processing. </span> </p>
                </div>
            </Modal>
        </>
    );
}
